import { Controller } from "@hotwired/stimulus";

// Cycles through Amazon marketplace flags with smooth crossfade transitions.
// Each burst sweeps consecutive flags left to right with randomized count and timing.
export default class extends Controller {
  static values = {
    urls: Object, // { "us": "/assets/flags/4x3/us-abc123.svg", ... }
    stagger: { type: Number, default: 200 },
  };

  connect() {
    this.slots = Array.from(this.element.querySelectorAll("[data-flag-slot]"));
    this.displayed = new Set(this.slots.map((slot) => slot.dataset.flagSlot));
    this.available = Object.keys(this.urlsValue).filter(
      (f) => !this.displayed.has(f),
    );

    this.scheduleNext();
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  scheduleNext() {
    // Random pause between 2–5s
    const delay = 2000 + Math.random() * 3000;
    this.timer = setTimeout(() => {
      this.burst();
      this.scheduleNext();
    }, delay);
  }

  burst() {
    // Random burst size: 2–4 flags
    const maxBurst = Math.min(4, this.available.length, this.slots.length);
    if (maxBurst < 2) return;
    const count = 2 + Math.floor(Math.random() * (maxBurst - 1));

    const start = Math.floor(Math.random() * (this.slots.length - count + 1));

    const replacements = [];
    for (let i = 0; i < count; i++) {
      const nextIndex = Math.floor(Math.random() * this.available.length);
      replacements.push(this.available.splice(nextIndex, 1)[0]);
    }

    for (let i = 0; i < count; i++) {
      setTimeout(
        () => this.swap(start + i, replacements[i]),
        i * this.staggerValue,
      );
    }
  }

  swap(slotIndex, nextFlag) {
    const slot = this.slots[slotIndex];

    const layers = slot.querySelectorAll("img");
    const visible = layers[0].classList.contains("opacity-0")
      ? layers[1]
      : layers[0];
    const hidden = visible === layers[0] ? layers[1] : layers[0];

    hidden.src = this.urlsValue[nextFlag];
    hidden.alt = nextFlag.toUpperCase();

    requestAnimationFrame(() => {
      hidden.classList.remove("opacity-0");
      visible.classList.add("opacity-0");
    });

    const oldFlag = slot.dataset.flagSlot;
    this.available.push(oldFlag);
    this.displayed.delete(oldFlag);
    this.displayed.add(nextFlag);
    slot.dataset.flagSlot = nextFlag;
  }
}
